module.exports = __webpack_public_path__ + "img/CM-MC-25-Toyota-Playful.4aad7cc9.jpg";